export var baseUrl = [window.location.protocol, '//', window.location.host].join('');